import React, { useEffect, useId, lazy, Suspense } from 'react';
import { RideType } from '../../../../views/ford-rides-view/ford-rides-view';
import { ReducerInitialStates } from '../../../../contexts/ford-rides-context/ford-rides-context';
import { FordRidesContentProps } from '../hooks/use-ford-rides-content';
import './rides-filter.scss';
import { useAnalytics } from '../../../../hooks/use-analytics';
import { ActivityIndicator } from '../../../common/activity-indicator/activity-indicator';

const RidesDistanceDurationFilter = lazy(() =>
    import('./rides-distance-duration-filter/rides-distance-duration-filter')
);

interface Props {
    rideType?: RideType[];
    setRideType?: (data: RideType[]) => void;
    state: ReducerInitialStates;
    fordRidesData: FordRidesContentProps;
}

const RidesFilter = (props: Props) => {
    const inputId = useId();
    const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const target = event.target as HTMLInputElement;
        const name = target.name;
        const isPresent = props.rideType?.includes(name as RideType);
        const currentData = isPresent
            ? props.rideType?.filter(i => i !== name)
            : [...(props.rideType || []), name];
        props?.setRideType && props?.setRideType(currentData as RideType[]);
    };
    const [fireEvents] = useAnalytics();

    useEffect(() => {
        fireEvents(['ford-rides-filter-cta'], undefined, undefined, false);
    }, []);

    return (
        <div
            data-testid="rides-filter-container"
            className="filter-rides-filter"
        >
            <div className="rides-filter">
                <div className="rides-filter-content">
                    <h2 className="heading">
                        {props.fordRidesData.filterHeadingText}
                    </h2>
                    <p className="description">
                        {props.fordRidesData.filterInfoText}
                    </p>
                    <ul className="filter-rides-list">
                        {Object.keys(props.state).map(stateKey => {
                            if (
                                props.state[
                                    stateKey as keyof ReducerInitialStates
                                ]?.length
                            ) {
                                return (
                                    <li className="list-item" key={stateKey}>
                                        <input
                                            type="checkbox"
                                            name={stateKey}
                                            id={`${stateKey}-${inputId}`}
                                            checked={props.rideType?.includes(
                                                stateKey as keyof ReducerInitialStates
                                            )}
                                            disabled={
                                                (props.rideType || []).length <
                                                    2 &&
                                                props.rideType?.includes(
                                                    stateKey as keyof ReducerInitialStates
                                                )
                                            }
                                            className="filter-input"
                                            onChange={handleFilterChange}
                                        />
                                        <label
                                            htmlFor={`${stateKey}-${inputId}`}
                                            className="filter-input-label"
                                        >
                                            {
                                                props.fordRidesData[
                                                    stateKey as keyof FordRidesContentProps
                                                ]
                                            }
                                        </label>
                                    </li>
                                );
                            } else {
                                return <></>;
                            }
                        })}
                    </ul>
                </div>
                <Suspense fallback={<ActivityIndicator />}>
                    <RidesDistanceDurationFilter />
                </Suspense>
            </div>
        </div>
    );
};

export default RidesFilter;
